import React from 'react';

interface StepperProps {
  items: { status: string }[];
  currentIndex: number;
  onStepClick: (index: number) => void;
}

const ProgressStepper: React.FC<StepperProps> = ({ items, currentIndex, onStepClick }) => {
  return (
    <div className="stepper-container">
      {items.map((item, index) => (
        <button 
          key={index}
          className={`step-item status-${item.status} ${index === currentIndex ? 'active' : ''}`}
          onClick={() => onStepClick(index)}
          title={`Sentence ${index + 1}`}
        />
      ))}
    </div>
  );
};

export default ProgressStepper;